import { z } from "zod";
import { DocumentationItemHeaderV2, defaultDocumentationItemHeaderV2 } from "./item-header-v2";

export const DocumentationItemConfigurationV2 = z.object({
  showSidebar: z.boolean(),
  isPrivate: z.boolean().optional(),
  isHidden: z.boolean().optional(),
  header: DocumentationItemHeaderV2,
});

export type DocumentationItemConfigurationV2 = z.infer<typeof DocumentationItemConfigurationV2>;

export const defaultDocumentationItemConfigurationV2 = {
  header: defaultDocumentationItemHeaderV2,
  isHidden: false,
  isPrivate: false,
  showSidebar: true,
} as const;
